import React, { useEffect, useState } from "react";
import "./server.scss";

import ListServer from "./components/listServer/ListServer";
import SearchField from "../../components/searchField/SearchField";

import { Box, Stack } from "@mui/material";
import { getStatsServerWS } from "./serverApi";
import { gestioneSnackbar } from "../../utils/common";

const Server = () => {
  const [search, setSearch] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);

  const refreshContent = () => {
    getStatsServerWS()
      .then((res) => {
        setData(res);
        setFilteredData(res);
      })
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  useEffect(() => {
    refreshContent();
  }, []);

  useEffect(() => {
    if (search) {
      setFilteredData(
        data.filter((item) => {
          const name = item.name?.toLowerCase() || "";

          return name.includes(search.toLowerCase());
        })
      );
    } else {
      setFilteredData(data);
    }
  }, [search]);

  return (
    <Box>
      <Stack gap={2}>
        <SearchField setSearch={setSearch} />
        <ListServer data={filteredData} />
      </Stack>
    </Box>
  );
};

export default Server;
